/**
 * pdp-sibling-swatches--unified.js
 *
 * Handles the visual behaviour of sibling-product color swatches on the PDP.
 *
 * Since the swatches are <a> links (not radio inputs), Prestige's native
 * variant-picker JS doesn't manage them. This file handles:
 *
 *   1. Updating the selected color label next to "Color:" when hovering a swatch
 *   2. Restoring the label to the active (current) swatch on mouseleave
 *   3. Marking the correct swatch as is-selected on page load (in case the
 *      page is loaded via back/forward navigation or a direct URL)
 *
 * Add this file to your theme assets and include it via a <script> tag at the
 * bottom of variant-picker--unified.liquid (inside {% if request.page_type == 'product' %}).
 */

(function () {
  'use strict';

  function initPdpSiblingSwatches(scope) {
    scope = scope || document;

    const swatches = scope.querySelectorAll('[data-pdp-sibling-swatch]');
    if (!swatches.length) return;

    // There may be multiple fieldsets if the snippet is rendered more than once
    // (e.g. sticky header variant picker). Handle each independently.
    swatches.forEach(function (swatch) {
      const fieldset = swatch.closest('fieldset');
      if (!fieldset) return;

      const label = fieldset.querySelector('[data-pdp-sibling-selected-color]');

      // Hover: show swatch name in label
      swatch.addEventListener('mouseenter', function () {
        if (label) label.textContent = swatch.dataset.siblingColor;
      });

      // Leave: restore to the currently selected swatch name
      swatch.addEventListener('mouseleave', function () {
        if (!label) return;
        const selected = fieldset.querySelector('[data-pdp-sibling-swatch].is-selected');
        if (selected) {
          label.textContent = selected.dataset.siblingColor;
        }
      });
    });
  }

  // Init on DOMContentLoaded (PDP page load)
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initPdpSiblingSwatches(document);
    });
  } else {
    initPdpSiblingSwatches(document);
  }

  // Also expose for any dynamic re-renders
  window.initPdpSiblingSwatches = initPdpSiblingSwatches;
})();
